// 飞兔IM路由
export default [
    {
        path: '/evaluation',
        name: 'evaluation',
        component: () => import('@/views/flying-rabbit/evaluation/Evaluation.vue'),
        meta: { title: '满意度评价', keepAlive: true }
    },
    {
        path: '/sessionHistory',
        name: 'sessionHistory',
        component: () => import('@/views/flying-rabbit/session-history/SessionHistory.vue'),
        meta: { title: '会话历史记录', keepAlive: true }
    },
    {
        path: '/incomingLine',
        name: 'incomingLine',
        component: () => import('@/views/flying-rabbit/incoming-line/IncomingLine.vue'),
        meta: { title: '进线明细', keepAlive: true }
    },
    {
        path: '/overallService',
        name: 'overallService',
        component: () => import('@/views/flying-rabbit/overall-service/OverallService.vue'),
        meta: { title: '整体服务指标', keepAlive: true }
    },
    {
        path: '/flyingPersonalService',
        name: 'flyingPersonalService',
        component: () => import('@/views/flying-rabbit/personal-service/FlyingPersonalService.vue'),
        meta: { title: '个人服务指标', keepAlive: true }
    },
    {
        path: '/repeatIntoLine',
        name: 'repeatIntoLine',
        component: () => import('@/views/flying-rabbit/repeatInto-line/RepeatIntoLineTab.vue'),
        meta: { title: '重复进线明细', keepAlive: true }
    },
    {
        path: '/volumeDetails',
        name: 'volumeDetails',
        props: true,
        component: () => import('@views/flying-rabbit/_components/indicator-details/VolumeDetails'),
        meta: { title: '无效会话量明细', keepAlive: true }
    },
    {
        path: '/responsesDetails',
        name: 'responsesDetails',
        props: true,
        component: () => import('@views/flying-rabbit/_components/indicator-details/ResponsesDetails'),
        meta: { title: '客服未响应数明细', keepAlive: true }
    },
    {
        path: '/threeDetails',
        name: 'threeDetails',
        props: true,
        component: () => import('@views/flying-rabbit/_components/indicator-details/ThreeDetails'),
        meta: { title: '30s未响应量明细', keepAlive: true }
    },
    {
        path: '/dissatisfactionDetails',
        name: 'dissatisfactionDetails',
        props: true,
        component: () => import('@views/flying-rabbit/_components/indicator-details/DissatisfactionDetails'),
        meta: { title: '不满意量明细', keepAlive: true }
    },
    {
        path: '/flyOnlineServicer',
        name: 'flyOnlineServicer',
        component: () => import('@/views/flying-rabbit/online-servicer/FlyOnlineServicer.vue'),
        meta: { title: '在线客服列表', keepAlive: true }
    },
    {
        path: '/seatStatus',
        name: 'seatStatus',
        component: () => import('@/views/flying-rabbit/seat-status/SeatStatus.vue'),
        meta: { title: 'IM坐席状态统计报表', keepAlive: true }
    },
    {
      path: '/seatMonitoringHq',
      name: 'seatMonitoringHq',
      component: () =>import('@views/seat-monitoring/seatMonitoringHq.vue'),
      meta: { title: '坐席监控', keepAlive: true }
    },
    {
      path: '/CustomerService',
      name: 'CustomerService',
      props: true,
      component: () => import('@views/customer-service/CustomerService.vue'),
      meta: { title: '客服管理', keepAlive: true }
    },
    {
      path: '/SeatsPerformance',
      name: 'SeatsPerformance',
      props: true,
      component: () => import('@views/flying-rabbit/agent-performance/agentPerformance.vue'),
      meta: { title: '坐席绩效', keepAlive: true }
    },
    {
        path: '/onlineFCR',
        name: 'onlineFCR',
        component: () => import('@/views/flying-rabbit/fcr/IndexTab.vue'),
        meta: { title: '在线FCR报表', keepAlive: true }
    },
    {
        path: '/customerEfficacy',
        name: 'customerEfficacy',
        component: () => import('@/views/flying-rabbit/customer-efficacy/CustomerEfficacy.vue'),
        meta: { title: '客服效能报表', keepAlive: true }
    },
]
